import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check, Clock, X } from "lucide-react";
import { humanAdoptionSigner } from "@/lib/humanAdoptionStatus";
import type { AdoptionSigner } from "@/hooks/useCurrentEditionAdoption";

interface Props {
  signers: AdoptionSigner[];
  signedCount: number;
}

export default function AdoptionSignerProgressList({ signers, signedCount }: Props) {
  if (signers.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          Signatures: {signedCount} of {signers.length}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {signers.map((signer) => {
          const signed = signer.status === "signed";
          const declined = signer.status === "declined";
          const Icon = signed ? Check : declined ? X : Clock;
          return (
            <div
              key={signer.id}
              className="flex min-h-11 flex-wrap items-center justify-between gap-2 rounded-md border p-3"
            >
              <div>
                <div className="text-sm font-medium">{signer.signer_name}</div>
                <div className="text-xs text-muted-foreground">{signer.signer_email}</div>
              </div>
              <Badge variant={signed ? "default" : declined ? "destructive" : "secondary"} className="gap-1">
                <Icon className="h-3 w-3" />
                {humanAdoptionSigner(signer.status)}
              </Badge>
            </div>
          );
        })}
        <p className="text-xs text-muted-foreground">
          The adoption is done only after every member has signed.
        </p>
      </CardContent>
    </Card>
  );
}
